<app-mobile-header [visible]="showMobileChrome"></app-mobile-header>

<div
  class="app-container"
  [class.authenticated]="isAuthenticated"
  [class.projects-mobile-shell]="isProjectsRoute"
  [class.welcome-mobile-shell]="isWelcomeRoute"
>
  <!-- Fixed Side Navigation -->
  <div class="fixed-sidenav" [style.width]="navWidth">
    <div class="nav-item-flex">
      <div class="nav-content">
        <!-- Menu Toggle Button -->
        <div class="sidenav-header">
          <button mat-icon-button (click)="toggleSidenav()" class="menu-toggle-btn">
            <mat-icon>{{ isExpanded ? 'menu_open' : 'menu' }}</mat-icon>
          </button>
        </div>

        <div class="nav-list-container">
          <ng-container>
            <ng-container *ngFor="let menu of navMenu">
              <mat-divider
                *ngIf="menu.menutext === 'Admin'"
                class="nav-divider"
                [ngClass]="{ 'nav-menu-divider': isExpanded }"
              ></mat-divider>
              <ng-container *ngIf="!menu.children">
                <a
                  (click)="onNavClick()"
                  [routerLink]="['/', menu.route]"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  id="nav-{{ menu.menutext }}"
                  class="nav-item"
                  [matTooltip]="!isExpanded ? menu.tooltip : ''"
                  [matTooltipPosition]="'right'"
                  [matTooltipDisabled]="isExpanded"
                >
                  <mat-icon class="nav-icon" *ngIf="!menu.customIcon">{{ menu.icon }}</mat-icon>
                  <mat-icon class="nav-icon" *ngIf="menu.customIcon" [svgIcon]="menu.icon"></mat-icon>
                  <span class="nav-text" [class.hidden]="!isExpanded">{{ menu.menutext }}</span>
                </a>
              </ng-container>

              <ng-container *ngIf="menu.children">
                <div class="nav-expansion-container" [class.collapsed]="!isExpanded">
                  <div
                    class="nav-expansion-header"
                    [matTooltip]="!isExpanded ? menu.tooltip : ''"
                    [matTooltipPosition]="'right'"
                    [matTooltipDisabled]="isExpanded"
                    (click)="toggleExpansion(menu.id)"
                  >
                    <mat-icon class="nav-icon">{{ menu.icon }}</mat-icon>
                    <div class="d-flex">
                      <span class="nav-text" [class.hidden]="!isExpanded">{{ menu.menutext }}</span>
                      <mat-icon class="expand-icon" *ngIf="isExpanded">{{
                        isMenuExpanded(menu.id) ? 'expand_less' : 'expand_more'
                      }}</mat-icon>
                    </div>
                  </div>
                  <div class="nav-children" *ngIf="isMenuExpanded(menu.id)">
                    <a
                      (click)="onNavClick()"
                      *ngFor="let child of menu.children"
                      [routerLink]="['/', child.route]"
                      routerLinkActive="active"
                      [routerLinkActiveOptions]="{ exact: true }"
                      id="nav-{{ child.menutext }}"
                      class="nav-item nav-child-item"
                    >
                      <mat-icon class="nav-icon" *ngIf="!child.customIcon">{{ child.icon }}</mat-icon>
                      <mat-icon class="nav-icon" *ngIf="child.customIcon" [svgIcon]="child.icon"></mat-icon>
                      <span class="nav-text" [class.hidden]="!isExpanded">{{ child.menutext }}</span>
                    </a>
                  </div>
                </div>
              </ng-container>
            </ng-container>
          </ng-container>
        </div>

        <!-- User Authentication Section -->
        <div class="nav-list-container" [class.collapsed]="!isExpanded">
          <ng-container>
            <mat-divider class="nav-menu-divider"></mat-divider>

            <ng-container>
              <div
                *ngIf="!isAuthenticated"
                class="nav-item"
                (click)="login()"
                [matTooltip]="!isExpanded ? 'Sign In' : ''"
                [matTooltipPosition]="'right'"
                id="login-btn"
              >
                <mat-icon class="nav-icon">login</mat-icon>
                <span class="nav-text">Sign In</span>
              </div>
            </ng-container>
            <div *ngIf="isAuthenticated" class="auth-info">
              <div
                class="nav-item"
                style="cursor: default"
                [matTooltip]="userName.length > 8 ? userName : ''"
                matTooltipPosition="below"
                id="logged-in-user"
              >
                <mat-icon class="">account_circle</mat-icon>
                <span class="nav-text" [class.hidden]="!isExpanded">{{
                  userName.length > 8
                    ? (userName | slice: 0 : 8) +
                      '
                  ...'
                    : userName
                }}</span>
              </div>
              <div *ngIf="hasMultipleTenants" class="nav-item" (click)="switchTenant()" id="switch-tenant-btn">
                <mat-icon class="nav-icon">swap_horiz</mat-icon>
                <span class="nav-text" [class.hidden]="!isExpanded">{{
                  selectedTenantName
                    ? selectedTenantName
                    : 'Select
                  Tenant'
                }}</span>
              </div>
              <div class="nav-item" (click)="logout()" id="logout-btn">
                <mat-icon class="nav-icon">logout</mat-icon>
                <span class="nav-text" [class.hidden]="!isExpanded">Sign Out</span>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
      <div class="nav-merge-date" *ngIf="appVersion">V_{{ appVersion }}</div>
    </div>
  </div>

  <!-- Main Content Area -->
  <div class="main-content-area" [style.margin-left]="marginLeft">
    <router-outlet></router-outlet>
  </div>
</div>

<app-mobile-footer
  [visible]="showMobileChrome"
  [hasMultipleTenants]="hasMultipleTenants"
  [userName]="userName"
  (tenantSelected)="switchTenant()"
  (logoutSelected)="logout()"
>
</app-mobile-footer>
